// extracted by mini-css-extract-plugin
export default {"backbutton":"BackButton_backbutton__Qd3m4"};